import workflowStatuses from '../assets/workflow-statuses.json'

export default function getWorkflowStatuses({ module, isQualityAssurance, rejectIsDisabled } = {}) {
    return workflowStatuses.map(outcome => {
        var disabled = false;
        if (isQualityAssurance) {
            if (!isQualityAssurance && outcome.is_quality_assurance) {
                disabled = true;
            }
            if (isQualityAssurance && !outcome.is_quality_assurance) {
                disabled = true;
            }
        } else if (module) {
            if (outcome?.include_in && !outcome?.include_in.includes(module)) {
                disabled = true;
            }
            if (outcome?.exclude_from && outcome?.exclude_from.includes(module)) {
                disabled = true;
            }
            if (outcome?.is_quality_assurance && !isQualityAssurance) {
                disabled = true
            }
        }
        if (outcome.value === "Reject" && rejectIsDisabled) {
            disabled = true;
        }
        return {
            "label": outcome.label,
            "value": outcome.value,
            "disabled": disabled,
            "always_filterable": outcome.always_filterable
        }
    })
}